angular.module('qkr.partner.reports')
    .controller('CurrentPartnerReportsController', function ($routeSegment, reportService, reports, $uibModal,
                                                             utils, $log) {
        const vm = this;

        vm.savedReports = reports;

        vm.unsuspendPartnerSavedReport = (savedReport, index) => {
            reportService.unsuspendPartnerReport(savedReport.id)
                .then(data => {
                    vm.savedReports[index] = angular.copy(data);
                })
                .catch(error => {
                    $log.error(error);
                });
        };

        vm.suspendPartnerSavedReport = (savedReport, index) => {
            const modalInstance = $uibModal.open({
                template: require('../../../templates/report/reportSuspendDatepicker.html'),
                controller: 'ReportSuspendDatePickerController',
                windowClass: 'modal',
                backdrop: 'static'
            });

            modalInstance.result.then(result => {
                if (result !== 'cancel') {
                    vm.savedReports[index].saving = true;
                    reportService.suspendPartnerReport(vm.savedReports[index], result)
                        .then((promise) => {
                            vm.savedReports[index] = angular.copy(promise);
                            vm.savedReports[index].saving = false;
                        })
                        .catch(error => {
                            vm.savedReports[index].saving = false;
                            $log.error(error);
                        });
                }
            });
        };

        vm.deletePartnerSavedReport = function (savedReport) {
            const promiseMap = {
                PartnerFinance1ReportSpec: reportService.deletePartnerFinance1Report(savedReport.id)
            };
            const promise = promiseMap[savedReport.bean];
            promise
                .then(() => $routeSegment.chain[1].reload())
                .catch(error => $log.error(error));
        };

        vm.editPartnerSavedReport = function (savedReport) {

            let modalInstance;

            const reportCopy = Object.assign({}, savedReport);

            if (savedReport.bean === 'PartnerFinance1ReportSpec') {
                modalInstance = $uibModal.open({
                    template: require('../schedule/finance1.html'),
                    controller: 'PartnerFinance1ControllerModal as vm',
                    windowClass: 'modal-huge',
                    backdrop: 'static',
                    resolve: {
                        savedReport() {
                            return reportCopy;
                        },
                        reportInfo() {
                            return {
                                report: reportCopy
                            };

                        },
                    }
                });
            }

            modalInstance.result
                .then(() => $routeSegment.chain[1].reload())
                .catch(() => $log.error('fail'));
        };

        vm.scheduleSummary = function (savedReport) {
            return reportService.scheduleSummary(savedReport);
        };

        vm.getReportType = function (report) {
            return reportService.getReportType(report);
        };

        vm.getNextScheduledGeneration = function (report) {
            return utils.serverDateStringtoDate(report.nextScheduledGenerationDisplay);
        }

    });



// WEBPACK FOOTER //
// ./src/reports/partner/current/current.component.js